import { MinzeElement } from 'minze'

export interface LvcGoogleIcon {}

export class LvcGoogleIcon extends MinzeElement {
  html = () => `
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.271 4.6665C18.5083 4.6665 20.5933 5.28388 22.3616 6.35126L21.3824 7.31115C19.8791 6.45138 18.1328 5.95717 16.271 5.95717C10.6723 5.95717 6.06518 10.4164 6.06518 15.9998C6.06518 21.5833 10.6723 26.0425 16.271 26.0425C20.979 26.0425 24.3638 23.2383 25.5852 19.3452L26.4006 16.7465H23.677H18.271V15.6545L27.3252 15.6668C27.4037 17.6972 26.9449 20.247 25.6588 22.4376C24.0888 25.1117 21.2492 27.3332 16.271 27.3332C9.82394 27.3332 4.66675 22.2215 4.66675 15.9998C4.66675 9.77815 9.82394 4.6665 16.271 4.6665Z" fill="#1E007D" stroke="#1E007D" stroke-width="4"/>
  </svg>
  `

  css = () => `
    
  `
}
